import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import { useGetRewardsStatsQuery } from '@/shared/api/Stats';
import { useGetBalanceByCoinQuery } from '@/shared/api/Payouts';
import { useSelector } from 'react-redux';
import { selectPollingInterval } from '@/processes/Settings';
import { useCurrencyWithExchange, useCryptoFormatter, useThreshold } from '@/processes/PoolStats';
import CoinStats from '@/entities/CoinStats';
import { useMinerAccount } from "@/processes/MinerAccounts";
import Tooltip from '@/shared/ui/Tooltip';
import { IconInfo } from '@/shared/ui/Icons';

type BalanceProps = {
  className?: string;
}

const Balance = (props: BalanceProps) => {
  const {
    className = '',
  } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const { account, miner, coin } = useMinerAccount();
  const { threshold } = useThreshold({ coin })
  const { formatCurrency } = useCurrencyWithExchange({ coin })
  const { formatCrypto, addCoinPostfix } = useCryptoFormatter({ coin })
  const { data: balance = 0 } = useGetBalanceByCoinQuery({ account, coin, miner }, { pollingInterval, skip: !(account || miner) });
  const { data: rewardsStats = {}, isLoading } = useGetRewardsStatsQuery(
    { account, coin, miner },
    { pollingInterval, skip: !(account || miner) }
  );
 
  const unpaid = _get(rewardsStats, 'unpaid', 0);
  // Unpaid balance calculations (provided by Vova)
  // rewards-stats.available + rewards-stats.locked + estimated-income.unverifiedAmount
  // const unpaidWithUnverified = unpaid + unverifiedAmount;
  return (
    <CoinStats
      className={className}
      isLoading={isLoading}
      coin={coin}
      label={
        <Tooltip
          ToggleComponent={
            <span className="flex items-center">
              <span className="mr-1">
                {intl.formatMessage({ id: 'stats.unpaid' })}
              </span>
              <IconInfo/>
            </span>
          }
        >
          { intl.formatMessage({ id: 'stats.payoutHint' })}
        </Tooltip>
      }
      value={formatCrypto(balance)}
      subValue={addCoinPostfix(threshold)}
      tip={formatCurrency(unpaid)}
    />
  );
}

export default Balance;
